<template>
    <div>
        <a class="blue-text add-comment-link record-btn-link comment-link" v-if="!commentArea" @click.prevent="showCommentArea()">
            <i class="icon-add-text"></i>
            Add text comment
        </a>
        <a class="blue-text add-comment-link record-btn-link disabled-button" v-if="!commentArea && isRecording && recordingInfo && recordingInfo.id !== task.id" @click.prevent="">
            <i class="icon-record"></i>
            Recording in another task...
        </a>
        <a class="blue-text add-comment-link record-btn-link disabled-button uploading-video" v-else-if="!commentArea && (uploadingInProcess || (recordingInfo && recordingInfo.clicked))" @click.prevent="">
            <span class="add-comment-link">
                <i class="icon-record"></i>
                Add screen comment
            </span>
            <!-- Do we need this? -->
            <!-- <div :style="{width: uploadingStatus + '%'}" class="uploading-status-line"></div>
            <p class="uploading-status-text">{{ uploadingStatus }}% Uploading</p> -->
        </a>
        <a class="blue-text add-comment-link record-btn-link" v-else-if="recordingInfo && recordingInfo.recording && recordingInfo.id == task.id" @click.prevent="stopRecord">
            <div class="record-indicator"></div>
            <div class="stop-record"></div>
            Stop & Preview
        </a>
        <a class="red-text add-comment-link record-btn-link" v-else-if="!commentArea" @click.prevent="startRecord">
            <i class="icon-record"></i>
            Add screen comment
        </a>

        <div class="comment-area-wrap" v-if="commentArea">
            <div :class="[showUsersSuggestions ? 'show' : '', 'user-suggestion-block']">
                <ul class="users-list" ref="usersList">
                    <li
                        v-for="user in tags"
                        :key="user.id"
                    >
                        <a
                            href="#"
                            @click.prevent="addUserSelect(user)"
                            :data-id="user.id"
                        >
                            <div class="img-holder">
                                <img :src="user.portrait" :alt="user.username">
                            </div>
                            {{ user.username }}
                        </a>
                    </li>
                </ul>
            </div>
            <div :class="[showCommandsSuggestions ? 'show' : '', 'commands-suggestion-block']">
                <ul class="commands-list" ref="commandsList">
                    <li
                        v-for="(cmd, i) in commands"
                        :key="i"
                    >
                        <a
                            href="#"
                            @click.prevent="addMDSelect(cmd)"
                            :data-id="i"
                        >
                            {{ cmd.label }}
                        </a>
                    </li>
                </ul>
            </div>
            <TextArea
                class="texarea-comment"
                v-model="commentText"
                placeholder="Add a comment..."
                inputClass="mb-10"
                :required="true"
                :overflow="true"
                :data-active="this.showCommandsSuggestions || this.showUsersSuggestions"
                ref="commentTextarea"
                @blur="() => commentText.trim().length <= 0 ? setCommentTextareaAutoHeight() : ''"
                @input="setTextareaHeight('commentTextarea')"
                @ctrlEnter="addComment"
                @keydown="keyDownHandler"
                @keyup="keyUpHandler"
            />
            <div ref="mute-calc-block" class="mute-calc-block">
                <span v-html="f_commentText"></span><span class="position"></span>
            </div>
            <span class="hint">Press Control + Enter to Comment</span>
            <VButton
                :active="Boolean(commentText?.trim().length)"
                :disabled="commentText?.trim() == '' "
                @mouseDown="addComment"
            >Comment</VButton>
            <VButton class="cancel-comment-btn" @mouseDown="() => $refs['confirm-comment-leave'].showModal()">Cancel</VButton>
            
            <VModal ref="confirm-comment-leave" class="confirm-comment-leave cant-hide" size="sm">
                <p class="text-center mb-3">Continue editing comment or cancel</p>
                <div class="btn-holder">
                    <VButton @clickHandler="continueMessage" theme="orange" active>Continue</VButton>
                    <VButton @clickHandler="cancelComment" theme="orange">Cancel</VButton>
                </div>
            </VModal>

            <Flash ref="show"/>
        </div>
    </div>

</template>
<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton";
import TextArea from "@/components/atoms/TextArea.vue";
import textareaCaret from 'textarea-caret';
import VModal from '@/components/atoms/VModal'
import { mapState } from 'vuex';

export default {
    name: "NewComment",
    components: {
        VButton,
        Flash,
        TextArea,
        VModal
    },
    props: ["users_tags", "task", "fileUploaded"],
    data: function () {
        return {
            commentText: '',
            showUsersSuggestions: false,
            searchUser: null,
            searchCommand: null,
            tags: this.users_tags,
            showCommandsSuggestions: false,
            commentArea: false,
            commands: [
                {label: 'Checklist', code: '- [ ] Checklist item', newLine: true, selectionStart: 4, selectionEnd: 18},
                {label: 'Boldface', code: '**Your text**', selectionStart: 2, selectionEnd: 11},
                {label: 'Italic', code: '*Your text*', selectionStart: 1, selectionEnd: 10},
                {label: 'Header 1', code: '# H1', newLine: true, selectionStart: 0, selectionEnd: 2},
                {label: 'Header 2', code: '## H2', newLine: true, selectionStart: 1, selectionEnd: 3},
                {label: 'Header 3', code: '### H3', newLine: true, selectionStart: 2, selectionEnd: 4},
                {label: 'Horizontal Line', code: '---', newLine: true, selectionStart: 5, selectionEnd: 5},
            ],
            holder: null
        };
    },
    async mounted() {
		document.querySelector('body').addEventListener('click', (e) => {
			if(!this.findParentTag(e.target, this.$el)) {
				this.showUsersSuggestions = false;
                this.showCommandsSuggestions = false
			}
		});
    },
    created() {
        window.addEventListener('keydown', this.handleKeydown);
    },
    methods: {
        handleKeydown(event) {
            if (event.key !== 'Escape') return;

            if (this.showCommandsSuggestions || this.showUsersSuggestions) {
                this.hideUserSuggestion()
            } else if (this.isCommenting && !this.showCommandsSuggestions && !this.showUsersSuggestions) {
                this.$emit('hiddenCancel')
            }
        },
        hideUserSuggestion() {
            this.$el.querySelectorAll('.users-list a').forEach(i => i.classList.remove('hover'))
            this.$el.querySelectorAll('.commands-list a').forEach(i => i.classList.remove('hover'))
            this.showUsersSuggestions = false
            this.showCommandsSuggestions = false
            this.searchUser = null
            this.searchCommand = null
            this.tags = this.users_tags;
        },
        keyUpHandler(e) {
            if(e.key === 'Backspace' && e.target.value.slice(-1) == '@') {
                this.searchUser = ''
                this.showUsersSuggestions = true
                this.holder[0].classList.add('hover')
            } else if (e.key === 'Backspace' && e.target.value.slice(-1) == '/') {
                this.searchCommand = ''
                this.showCommandsSuggestions = true
                this.holder[0].classList.add('hover')
            } else if(e.key === 'Backspace' && e.target.value.slice(-1) != '@') {
                this.hideUserSuggestion()
            } else if(e.key === 'Backspace' && e.target.value.slice(-1) != '/') {
                this.hideUserSuggestion()
            } else if (e.key === 'Escape') {
                e.preventDefault();
                this.hideUserSuggestion();
            }

            if(this.commentText.length == 0) {
                this.hideUserSuggestion()
            }
        },
        calcDropPosition() {
            const textarea = this.$refs['commentTextarea'].$el.querySelector('textarea')
            const caret = textareaCaret(textarea, textarea.selectionEnd);

            this.$el.querySelector('.user-suggestion-block').style.top = caret.top + 30 + 'px';
            this.$el.querySelector('.user-suggestion-block').style.left = caret.left + 'px';
            this.$el.querySelector('.commands-suggestion-block').style.top = caret.top + 30 + 'px';
            this.$el.querySelector('.commands-suggestion-block').style.left = caret.left + 'px';
        },
        setCommentTextareaAutoHeight() {
            // this.$refs['commentTextarea'].$el.querySelector('textarea').style.height = 'auto';
            // this.commentArea = false;
            // this.$store.dispatch('setCommenting', false)
        },
        keyDownHandler(e) {
            if(e.key === '@') {
                this.holder = this.$el.querySelectorAll('.users-list a')
                this.searchUser = ''
                this.showUsersSuggestions = true
                this.showCommandsSuggestions = false
                this.calcDropPosition()
                this.holder[0].classList.add('hover')
            } else if (e.key === '/') {
                this.holder = this.$el.querySelectorAll('.commands-list a')
                this.searchCommand = ''
                this.showCommandsSuggestions = true
                this.showUsersSuggestions = false
                this.calcDropPosition()
                this.holder[0].classList.add('hover')
            } else if(e.key === 'Enter') {
                if(this.showUsersSuggestions || this.showCommandsSuggestions) e.preventDefault()
                let activeID = null;
                if (this.holder && this.holder.length > 0) {
                    this.holder.forEach(i => {
                        if(i.classList.contains('hover')) {
                            activeID = i.getAttribute('data-id')
                            return
                        }
                    })
                    this.holder.forEach(i => i.classList.remove('hover'))
                }
                if (this.showUsersSuggestions) {
                    this.addUserSelect(this.users_tags.find(t => t.id == activeID))
                    this.searchUser = null
                    this.searchCommand = null
                    this.tags = this.users_tags;
                } else {
                    this.addMDSelect(this.commands[activeID])
                }
            } else if(e.code === 'Space') {
                this.hideUserSuggestion()
            } else if(e.key === 'ArrowDown' && (this.showUsersSuggestions || this.showCommandsSuggestions)) {
                e.preventDefault()
                this.navigateDropDown()
            } else if(e.key === 'ArrowUp' && (this.showUsersSuggestions || this.showCommandsSuggestions)) {
                e.preventDefault()
                this.navigateDropUp(e)
            }

            if(this.searchUser != null && e.code.indexOf('Key') == 0) {
                this.searchUser += e.key
                this.sortUsers()
                setTimeout(() => {
                    this.$el.querySelector('.users-list a')?.classList.add('hover')
                }, 100);
            }

            if(this.searchCommand != null && e.code.indexOf('Key') == 0) {
                this.searchCommand += e.key
                setTimeout(() => {
                    this.$el.querySelector('.users-list a')?.classList.add('hover')
                }, 100);
            }

            if (!this.searchUser && this.tags.length == 0) {
                this.hideUserSuggestion()
            }

            if (this.searchCommand && this.searchCommand.length > 0) {
                this.hideUserSuggestion()
            }
        },
        sortUsers() {
            let searchUser = this.searchUser.charAt(0) == '@' ? this.searchUser.slice(1) : this.searchUser
            this.tags = this.users_tags.filter(t => {
                return t.username.toLowerCase().includes(searchUser.toLowerCase())
            })
        },
        addUserSelect(user) {
            const textarea = this.$refs['commentTextarea'].$el.querySelector('textarea')
            const caretPos = textarea.selectionStart
            if(this.showUsersSuggestions) {
                if (this.searchUser) {
                    const splitted = this.commentText.split(/(?=[\s@])/)
                    const newComment = splitted.map(word => word == `@${this.searchUser}` ? `@${user.username} ` : word)
                    this.commentText = newComment.join('')
                } else {
                    const selectionStart = textarea.selectionStart;
                    const selectionEnd = textarea.selectionEnd;
    
                    const textBeforeSelection = this.commentText.substring(0, selectionStart);
                    const textAfterSelection = this.commentText.substring(selectionEnd);
    
                    this.commentText = textBeforeSelection + user.username + textAfterSelection
                }
                this.showUsersSuggestions = false
                setTimeout(() => {
                    textarea.focus()
                    textarea.setSelectionRange(caretPos + user.username.length, caretPos + user.username.length)
                }, 10);
            }
        },
        setTextareaHeight(refItem) {
            const childTextareEl = this.$refs[refItem].$el.querySelector('textarea');
            childTextareEl.style.height = 'auto';
            childTextareEl.style.height = childTextareEl.scrollHeight + 5 + 'px';
        },
        addMDSelect(cmd) {
            if(this.showCommandsSuggestions) {
                const start = this.$refs['commentTextarea'].$el.querySelector('textarea').selectionStart
                const end = this.$refs['commentTextarea'].$el.querySelector('textarea').selectionEnd

                const textBefore = this.commentText.substring(0, start - 1);
                const textAfter = this.commentText.substring(end);

                let selectionStart = cmd.selectionStart
                let selectionEnd = cmd.selectionEnd

                let updatedText
                if (cmd.newLine) {
                    const updatedTxt = this.newLineCommand(textBefore, textAfter, cmd, selectionStart, selectionEnd)
                    updatedText = updatedTxt.text;
                    selectionStart = updatedTxt.selectionStart
                    selectionEnd = updatedTxt.selectionEnd
                } else {
                    updatedText = textBefore + cmd.code + textAfter;
                }

                this.commentText = updatedText
                this.showCommandsSuggestions = false
                setTimeout(() => {
                    this.$refs['commentTextarea'].$el.querySelector('textarea').focus()

                    if (cmd.newLine) {
                        this.$refs['commentTextarea'].$el.querySelector('textarea').selectionStart = start + selectionStart + 1
                        this.$refs['commentTextarea'].$el.querySelector('textarea').selectionEnd = start + selectionEnd + 1
                    } else {
                        this.$refs['commentTextarea'].$el.querySelector('textarea').selectionStart = start + selectionStart - 1
                        this.$refs['commentTextarea'].$el.querySelector('textarea').selectionEnd = start + selectionEnd - 1
                    }

                    this.setTextareaHeight('commentTextarea')
                }, 100);
            }
        },
        newLineCommand(textBefore, textAfter, cmd, selectionStart, selectionEnd) {
            if (textBefore.trim() !== "" && textAfter.trim() !== "") {
                var lines = textBefore.split('\n');
                var lineAbove = lines[lines.length - 1].trim();
                var lineBelow = textAfter.split('\n')[0].trim();

                if (lineAbove !== "" && lineBelow !== "") {
                    selectionStart++
                    selectionEnd++
                    return {
                        text: textBefore + "\n" + cmd.code + "\n" + textAfter,
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd
                    };
                } else {
                    selectionStart++
                    selectionEnd++
                    return {
                        text: textBefore + "\n" + cmd.code + textAfter,
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd
                    };
                }
            } else if (textBefore.trim() !== "") {
                selectionStart++
                selectionEnd++
                return {
                    text: textBefore + "\n" + cmd.code,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            } else {
                return {
                    text: cmd.code + "\n" + textAfter,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd
                };
            }
        },
        navigateDropDown() {
            //don't remove, fix for dropdown arrow navigation
            var state = false;

            this.$el.querySelectorAll(this.showUsersSuggestions ? '.users-list a' : '.commands-list a').forEach((item, i, list) => {
                // check if result-list item has HOVER class and it's not the last item - to switch hover class to a next item
                if(!state && item.classList.contains('hover') && (i+1 != list.length)) {
                    this.highlightOption(i+1, i);
                    state = true;

                    //scroll to hovered item
                    const hoverItem = this.$el.querySelector(this.showUsersSuggestions ? '.users-list a.hover' : '.commands-list a.hover');
                    if (!this.isElementVisible(hoverItem.parentElement.parentElement.parentElement)) {
                        hoverItem.parentElement.parentElement.parentElement.scrollIntoView();
                    }
                    this.$el.querySelector(this.showUsersSuggestions ? '.user-suggestion-block' : '.commands-suggestion-block').scrollTop = hoverItem.offsetTop;
                    
                //if result-list item is the last in the list - go to first item
                } else if(!state && item.classList.contains('hover') && (i+1 == list.length)) {
                    this.highlightOption(0, i);
                    state = true;

                    const hoverItem = this.$el.querySelector(this.showUsersSuggestions ? '.users-list a.hover' : '.commands-list a.hover');
                    if (!this.isElementVisible(hoverItem.parentElement.parentElement.parentElement)) {
                        hoverItem.parentElement.parentElement.parentElement.scrollIntoView();
                    }
                    this.$el.querySelector(this.showUsersSuggestions ? '.user-suggestion-block' : '.commands-suggestion-block').scrollTop = hoverItem.offsetTop;
                }
            })
        },
        highlightOption(n, i) {
            this.$el.querySelectorAll(this.showUsersSuggestions ? '.users-list a' : '.commands-list a')[n].classList.add('hover');
            this.$el.querySelectorAll(this.showUsersSuggestions ? '.users-list a' : '.commands-list a')[i].classList.remove('hover');
        },
        navigateDropUp(e) {
            var state = false;

            this.$el.querySelectorAll(this.showUsersSuggestions ? '.users-list a' : '.commands-list a').forEach((item, i) => {
                // check if result-list item has HOVER class and it's not the first item - to switch hover class to a next item
                if(!state && item.classList.contains('hover') && i != 0) {
                    this.highlightOption(i-1, i);
                    state = true;

                    //scroll to hovered item
                    const hoverItem = this.$el.querySelector(this.showUsersSuggestions ? '.users-list a.hover' : '.commands-list a.hover');
                    if (!this.isElementVisible(hoverItem.parentElement.parentElement.parentElement)) {
                        hoverItem.parentElement.parentElement.parentElement.scrollIntoView();
                    }
                    this.$el.querySelector(this.showUsersSuggestions ? '.user-suggestion-block' : '.commands-suggestion-block').scrollTop = hoverItem.offsetTop;

                //if result-list item is the first in the list - go to last item
                } else if(!state && item.classList.contains('hover') && i == 0) {
                    this.highlightOption(this.$el.querySelectorAll(this.showUsersSuggestions ? '.users-list a' : '.commands-list a').length-1, i);
                    state = true;

                    const hoverItem = this.$el.querySelector(this.showUsersSuggestions ? '.users-list a.hover' : '.commands-list a.hover');
                    if (!this.isElementVisible(hoverItem.parentElement.parentElement.parentElement)) {
                        hoverItem.parentElement.parentElement.parentElement.scrollIntoView();
                    }
                    this.$el.querySelector(this.showUsersSuggestions ? '.user-suggestion-block' : '.commands-suggestion-block').scrollTop = hoverItem.offsetTop;
                }
            })
        },
        isElementVisible(element) {
            var rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
		findParentTag(el, tag) {
			while(el.parentNode) {
				el = el.parentNode;
				if (tag == el) return el;
			}
			return null;
		},
        async addComment() {
            if (this.commentText.trim().length === 0)  return
            try {
                const data = {
                    body: this.commentText,
                    id: this.task.id,
                };

                const response = await api.post(`/task_comment`, data);

                if (response.status === 200) {
                    this.$store.dispatch('editTaskEvents', response.data.data)
                    this.setCommentTextareaAutoHeight()
                    this.commentText = ''
                    this.$emit('updateTaskEvents')
                    this.cancelComment()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg)
                console.error(e);
            }
        },
        showCommentArea() {
            this.commentArea = true;
            this.$store.dispatch('setCommenting', true)
            this.$nextTick(() => {
                this.$refs['commentTextarea'].$el.querySelector('textarea').focus();
            })
        },
        startRecord() {
            document.querySelector('.startRecordBtn').click()
            this.$store.dispatch('setRecordingInfo', {id: this.task.id, project_id: this.task.project_id, uploadFunc: this.fileUploaded, clicked: true})
        },
        stopRecord() {
            document.querySelector('.stopRecordBtn').click()
            document.querySelector('.stop-timer').click()
        },
        continueMessage() {
            this.$refs['confirm-comment-leave'].hideModal()
            this.$refs['commentTextarea'].$el.querySelector('textarea').focus()
        },
        cancelComment() {
            console.log('cancelComment')
            this.commentText = ''
            this.commentArea = false
            this.$store.dispatch('setCommenting', false)
            this.$emit('hiddenCancel')
        }
    },
    watch: {
        users_tags() {
            this.tags = this.users_tags;
        }
    },
    computed: {
        f_commentText() {
            return this.commentText.replace(/(?:\r\n|\r|\n)/g, '<br>')
        },
        userID() {
            return this.$store.getters.userID
        },
        ...mapState(['recordingInfo']),
        uploadingInProcess() {
            return this.$store.getters.uploadingInProcess
        },
        isCommenting() {
			return this.$store.getters.isCommenting
		},
        uploadingStatus() {
            return Math.floor(this.uploadingInProcess['current'] * 100 / this.uploadingInProcess['total'])
        },
        isRecording() {
            return this.$store.getters.isRecording
        }
    }
};
</script>

<style lang="scss">
.add-comment-link {
    cursor: pointer;

    &.disabled-button {
        pointer-events: none;
        user-select: none;
        opacity: .7;
    }

    &.comment-link {
        margin-right: 15px;
    }

    &.record-btn-link {
        display: inline-flex;
        align-items: center;
        gap: 3px;
    }

    &.uploading-video {
        flex-direction: column;
        align-items: flex-start;

        .uploading-status-line {
            height: 3px;
            background-color: #ff0000;
        }

        .uploading-status-text {
            color: #ff0000;
        }
    }

    .record-indicator {
        width: 14px;
        height: 14px;
        background-color: #F15D4A;
        border-radius: 50%;
    }

    .stop-record {
        width: 14px;
        height: 14px;
        background: #D9D9D9;
        margin: 0 7px;
    }
    .icon-edit::before {
        color: var(--accent);
    }
}

.add-comment-link.blue-text:hover {
    color: #70aaef;
}

.red-text {
    color: #F15D4A;
    &:hover {
        color: #f07969;
    }
}

.comment-area-wrap {
    margin-bottom: 50px;
    min-height: auto;
    position: relative;

    .textarea {
        min-height: auto;
        &:focus {
           min-height: 134px;
        }
    }

    .mute-calc-block {
        opacity: 0;
        position: absolute;
        z-index: -1;
        display: inline-block;
        color: transparent;
        top: 10px;
        left: 10px;
        line-height: 1.25;

        .position {
            width: 1px;
        }
    }
}

.hint {
    margin-bottom: 3px;
}

.cancel-comment-btn {
    margin-left: 7px;
}

.user-suggestion-block {
    border-radius: 10px;
    background: rgba(51, 68, 82, 0.80);
    backdrop-filter: blur(6px);
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 10;
    height: 150px;
    overflow-y: auto;
    overflow-x: hidden;
    opacity: 0;
    pointer-events: none;
    transform: translateY(15px);
    transition: .15s opacity, .15s transform;

    &.show {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }

    .users-list {
        padding: 0;
        margin: 0;
        list-style-type: none;

        a {
            display: flex;
            align-items: center;
            padding: 7px;
            transition: .3s background-color;

            &:hover,
            &.hover {
                background-color: $new-blue;
                color: var(--primary-bg);
            }
        }

        .img-holder {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 5px;
        }
    }
}
</style>
